import 'css-chunksrc/client/scenes/projectResourceDeactivation/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_1l6ez_1",
  "profession": "_profession_1l6ez_9",
  "avatar": "_avatar_1l6ez_15",
  "name": "_name_1l6ez_25",
  "email": "_email_1l6ez_31"
};